<!--v-if="Object.keys(deletableFilterObjects).length !== 0"-->
<template>
  <div
      v-if="Object.keys(filterObjects).length !== 0"
      class="search-filter-delete"
  >
    <div class="form-wrapper form-wrapper--no-asterisk form-wrapper--margin-2">

      <!-- title -->
      <div
          v-if="showTitle"
          class="filter-label"
      >
        <i class="fas fa-trash-alt d-none d-sm-block"></i>
        <label class="col-form-label">
          {{ $t('messages_nl.search-form.removeFilterTitle') }}
        </label>
      </div>
      <div class="input-with-icon">
        <div class="remove-filter-container">

          <!-- remove all filters button -->
          <a
              id="removeFilter_0"
              class="remove-all"
              @click="removeAllDeletableFilters(); $emit('clicked')"
          >
            {{ $t('messages_nl.search-form.removeFilter') }}
          </a>

          <!-- remove specific filter button -->
          <div
              v-for="(value, key) in filterObjects"
              :key="key"
              class="remove-single-filter boxed-widget--clean"
              @click="removeDeletableFilter(key); $emit('clicked')"
          >
            <i class="fas fa-times"></i>
            <p>{{ value }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'adivare-filter-delete',
  props: {
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  emits: ['clicked'],
  computed: {
    radio() {
      return this.$store.state.availableFilters.radio;
    },
    filterObjects() {
      let deletableFilters = {};
      let totalFiltersCount = 0;

      Object.entries(this.computedFilters).forEach(([key, value]) => {
        if (true === Array.isArray(this.computedFilters[key])) {
          totalFiltersCount += this.computedFilters[key].length || 0;

          return;
        }

        const filterName = this.getDeletableFilterName(key, value);
        if (
            undefined === filterName ||
            undefined === value ||
            undefined === this.defaultFilters[key] ||
            value === this.defaultFilters[key]
        ) {
          return;
        }

        totalFiltersCount++;
        deletableFilters[key] = filterName;
      })

      this.$emit('totalFilters', totalFiltersCount);

      return deletableFilters;
    },
    defaultFilters: {
      get() {
        return {
          ...this.$store.state.defaultFilters,
          sorting: this.$store.state.filters.sorting,
        }
      },
      set(filters) {
        this.$store.commit('updateDefaultFilters', filters);
      }
    },
    computedFilters: {
      get() {
        return {
          ...this.$store.state.filters.properties,
          ...this.$store.state.filters.location,
          ...this.$store.state.filters.price,
          sorting: this.$store.state.filters.sorting,
          page: 1,
        };
      },
      set(filters) {
        this.$emit('updateFilters', filters);
        this.$emit('updateCounts', filters);
      }
    }
  },
  methods: {
    // get readable name of deletable filter
    getDeletableFilterName(key, value) {
      if (
          'object' === typeof this.radio[key] &&
          'undefined' !== typeof this.radio[key].name &&
          'undefined' !== typeof this.radio[key].options
      ) {
        return this.getDeletableFilterNameFromOptions(this.radio[key].options, value);
      }

      // prices
      switch (key) {
        case 'from':
          return this.$t('messages_nl.search-form.price-from') + ' € ' + value;
        case 'till':
          return this.$t('messages_nl.search-form.price-till') + ' € ' + value;
      }

      return undefined;
    },
    // helper function for getDeletableFilterName()
    getDeletableFilterNameFromOptions(options, value) {
      for (const option of options) {
        if (
            'undefined' !== typeof option.value &&
            'undefined' !== typeof option.name &&
            option.value === value
        ) {
          return option.name;
        }
      }

      return '';
    },
    // remove filter with a certain filter id and then update filters
    removeDeletableFilter(filterId) {
      if (
          'undefined' !== typeof this.defaultFilters[filterId] &&
          'undefined' !== typeof this.computedFilters[filterId]
      ) {
        let filters = this.computedFilters;
        filters[filterId] = this.defaultFilters[filterId];
        this.computedFilters = filters;
      }
    },
    // return to default filters
    removeAllDeletableFilters() {
      this.computedFilters = this.defaultFilters;
    }
  }
}
</script>
